import { render, staticRenderFns } from "./page_500.vue?vue&type=template&id=9c4b90aa"
import script from "./page_500.vue?vue&type=script&lang=js"
export * from "./page_500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports